<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/setup/systemBalance")
          i.fa.fa-cog
          span.ml-1 {{ $t("ui.system_balance") }}
  div.row
    div.col-md-12
      div.card
        //- div.card-header
        div.card-body
          div.row
            div.col-sm-12.col-md-6.col-lg-6
              div.row
                div.col-sm-12.col-md-6.col-lg-6
                  div.card.card-accent-warning
                    div.card-header
                      i.fas.fa-dollar-sign
                      span.font-weight-bold(:title="$t('ui.system_balance')") {{ $t("ui.system_balance") }}
                    div.card-body
                      div
                        div.text-value
                          h1(:class="$helpers.fontClassName(totalBalance)" :title="$n(totalBalance, 'currency')") {{ $n(totalBalance, 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    grandTotalBalance: 0,
  }),
  computed: {
    totalBalance() {
      return this.grandTotalBalance;
    },
  },
  mounted: function() {
    this.getBalance();
  },
  methods: {
    getBalance: function() {
      let url = config.systemBalanceUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        audit_by: this.$store.getters.loginId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.grandTotalBalance = response.data.dt.length > 0 ? response.data.dt[0].system_balance : 0;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss">

.badge {
  padding: 2.5px 4px !important;
}
.text-value {
  h1 {
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
}
</style>